<template>
  <div class="b-menu-pagination-actions-next">
    <div class="b-menu-pagination-actions-next__button" :class="classes" :title="title" @click="onClick">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
      </svg>
    </div>
  </div>
</template>

<script>
import StoreHelper from '../store/helper'
import _ from 'lodash'

export default {
  name: 'b-menu-pagination-actions-next',
  methods: {
    onClick () { this.$emit('click') }
  },
  computed: {
    classes () {
      return _.get(StoreHelper.getPaginationNextButtonConfig(), 'classes', [])
    },
    title () {
      return _.get(StoreHelper.getPaginationNextButtonConfig(), 'title', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.b-menu-pagination-actions-next {
  height: 100%;
  width: 100%;

  &__button {
    height: 100%;
    width: 100%;
    background-color: #D3D3D3;
    border-radius: 50%;
    cursor: pointer;
  }

  svg {
    fill: white;
    height: 100%;
    width: 100%;
    padding-left: 5%;
  }
}
</style>
